export default {
  path: '/date-privacy-rule',
  component: () => import('./DatePrivacyAgreement'),
  meta: {
    title: '青藤Date隐私政策',
    designWidth:750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}
